import React from "react";
import {Redirect, useParams} from "react-router-dom";
import {Box, Link, Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";

export default function Error(props) {
    const params = useParams();
    const type = props.type ?? params.type;
    const {t} = useTranslation('common');
    const [redirect, setRedirect] = React.useState(false);

    React.useEffect(() => {
        setTimeout(() => {
            setRedirect(true)
        }, 30000);
    });

    const ErrorComponent = ({code, description}) => {
        return (
            <Stack alignItems="center">
                {code && <Typography variant="h1">{code}</Typography>}
                {description && <Typography variant="h5">{description}</Typography>}
                <Box mt={5}>
                    <Link href="/">
                        <Typography sx={{color: theme => theme.palette.secondary.dark}}>
                            {t("main.pages.error.return")}
                        </Typography>
                    </Link>
                </Box>
            </Stack>
        );
    }

    if (redirect) return <Redirect to={"/"}/>

    const render = (type) => {
        switch (type) {
            case "notfound":
                return <ErrorComponent code={404} description={t("main.pages.error.notfound")}/>
            case "noresponse":
                return <ErrorComponent code={t("main.pages.error.oops")}
                                       description={t("main.pages.error.noresponse")}/>
            default:
                return <ErrorComponent code={t("main.pages.error.oops")} description={t("main.pages.error.other")}/>
        }
    }

    return (
        <>
            {render(type)}
        </>
    );
}

Error.propTypes = {
    type: PropTypes.string,
};
